import { environment } from '../../environment';

// const environment = require('../../environment');

const { apiInfo, userService, reportingService } = environment(import.meta.env.VITE_env);
const onboarding = {
  customers: {
    path: '/onboarding/customers/request'
  },
  attachments: {
    path: '/onboarding/attachments'
  },
  edi: {
    path: '/onboarding/edi/customer'
  },
  odata: {
    path: '/odata'
  },
  privacyPolicy: {
    path: '/onboarding/policyresponse'
  },
  activeRequests: {
    path: '/onboarding/customers/requestinfo'
  }
};
const users = {
  sessions: {
    path: '/users/sessions'
  }
};

const reporting = {
  help: {
    path: '/help'
  }
};

/**
 * @param {string} path - The api path you want to make the request to
 * @param {number} [interval=0] - The interval of time you want for a constant request
 * @param {number} [retry=0] - The number of times you want to retry making the request before it fails
 * @param {number} [timeout=2000] - The time you want to wait before the request fails
 * @returns {Object} - Configuration object with the request url with api path
 */
function buildConfig({ path = '', timeout = 2000, service = apiInfo, url }) {
  return {
    url: url || `${service.host}${service.path}${path}`,
    timeout
  };
}

/**
 * @typedef {Object} APIConfigService
 * @function getCustomer @returns - Configuration for the get customer api request
 * @function updateCustomer @returns - Configuration for the update customer api request
 * @function submitCustomer @returns - Configuration for the submit customer api request
 * @function validateCustomer @returns - Configuration for the validate customer api request
 * @function getAttachments @returns - Configuration for the get attachments api request
 * @function uploadAttachments @returns - Configuration for the upload attachments api request
 * @function submitHelpRequest @returns - Configuration for the help api request
 * @function getSignatureStatus @returns - Configuration for the status of the financials signing
 * @function requestSignature @returns - Configuration for the viewing of the financials signing
 * @function revokeToken @returns - Configuration for the revoking the user's token
 */
const APIConfigService = {
  getCustomer: () => buildConfig({ path: onboarding.customers.path }),
  updateCustomer: () => buildConfig({ path: onboarding.customers.path, timeout: 4000 }),
  submitCustomer: () => buildConfig({ path: onboarding.customers.path }),
  validateCustomer: () => buildConfig({ path: `${onboarding.customers.path}/validate` }),
  getAttachments: () => buildConfig({ path: onboarding.attachments.path }),
  uploadAttachments: () => buildConfig({ path: `${onboarding.attachments.path}/upload` }),
  submitHelpRequest: () =>
    buildConfig({
      path: `${reporting.help.path}/submit`,
      service: reportingService
    }),
  downloadAttachments: (fileName, hcId) =>
    buildConfig({
      path: `${onboarding.attachments.path}/download/${hcId}/${fileName}`
    }),
  removeAttachments: (fileName, hcId) => buildConfig({ path: `${onboarding.attachments.path}/${hcId}/${fileName}` }),
  revokeToken: () => buildConfig({ path: users.sessions.path, service: userService }),
  ediData: () => buildConfig({ path: onboarding.edi.path }),
  getOdataCountry: () =>
    buildConfig({
      path: `${onboarding.odata.path}/country`,
      service: reportingService
    }),
  getOdataState: countryCode =>
    buildConfig({
      path: `${onboarding.odata.path}/${countryCode}`,
      service: reportingService
    }),
  updateEdiData: hcId => buildConfig({ path: `${onboarding.edi.path}/${hcId}` }),
  privacyPolicy: () => buildConfig({ path: onboarding.privacyPolicy.path }),
  getActiveRequests: () => buildConfig({ path: onboarding.activeRequests.path })
};

export default APIConfigService;
